import Component from './sign-in-sms';
export default Component;
